module.exports = __webpack_public_path__ + "static/media/ARBITRUM.d3af9034.svg";